import { render, staticRenderFns } from "./AkunBankPenelitiKeamanan.vue?vue&type=template&id=51b37acc&scoped=true&"
import script from "./AkunBankPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./AkunBankPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b37acc",
  null
  
)

export default component.exports